import { 
  NomenclaturaDto,
  TipoViaDto,
  ApendiceDto, 
  CardinalidadDto,
  TipoDireccionDto
} from '../../shared/models/nomenclatura';

/**
 * Puerto: NomenclaturaRepository
 * 
 * Define el contrato para acceso a nomenclatura del sistema.
 * La implementación concreta está en infrastructure/adapters/nomenclatura/
 * 
 * Arquitectura Hexagonal:
 * - Presentation → inyecta este PUERTO (abstract class)
 * - Infrastructure → implementa este puerto (HttpNomenclaturaRepository)
 * 
 * @author Emerson Rodriguez - Ingeneo
 */
export abstract class NomenclaturaRepository {
  
  /**
   * Búsqueda genérica de nomenclatura por categoría
   */
  abstract buscarPorCategoria(parametro2: string): Promise<NomenclaturaDto[]>;
  
  /**
   * Lista tipos de vía
   */
  abstract listarTiposVia(): Promise<TipoViaDto[]>;
  
  /**
   * Lista apéndices
   */
  abstract listarApendices(): Promise<ApendiceDto[]>;
  
  /**
   * Lista cardinalidades
   */
  abstract listarCardinalidades(): Promise<CardinalidadDto[]>;
  
  /**
   * Lista tipos de dirección por persona
   */
  abstract listarTiposDireccionPorPersona(cdPersona: number): Promise<TipoDireccionDto[]>;
  
  /**
   * Lista estratos socioeconómicos
   */
  abstract listarEstratos(): Promise<NomenclaturaDto[]>;
  
  /**
   * Lista roles de contacto
   */
  abstract listarRoles(): Promise<NomenclaturaDto[]>;
  
  /**
   * Lista cargos de contacto
   */
  abstract listarCargos(): Promise<NomenclaturaDto[]>;
  
  // =========================================================================
  // MÉTODOS DE CONVERSIÓN (helpers para componentes Angular)
  // =========================================================================
  
  /**
   * Convierte lista de nomenclatura a formato PrimeNG dropdown
   */
  abstract toDropdownOptions(items: NomenclaturaDto[], includeEmpty?: boolean): { label: string; value: string }[];
  
  /**
   * Convierte tipos de dirección a formato PrimeNG dropdown
   * Usa 'consecutivo' (number) como value para nmtipo_persona_direccion
   */
  abstract toTipoDireccionDropdownOptions(items: TipoDireccionDto[], includeEmpty?: boolean): { label: string; value: number | null }[];
}
